import axiosInstance from "../../api/axiosInstance";

export const fetchChatsAPI = (page = 1, limit = 10, username = "") => {
  return axiosInstance.get(
    `/supportChat/get-all-chats?page=${page}&limit=${limit}&username=${username}`
  );
};

export const fetchChatMessagesAPI = (chatId, params = {}) => {
  return axiosInstance.get(`supportChat/${chatId}/messages`, {
    params,
  });
};

export const sendSupportMessageAPI = (chatId, message) => {
  return axiosInstance.post(`supportChat/${chatId}/message`, { message });
};

export const markMessagesAsReadByAdminAPI = (chatId) => {
  return axiosInstance.patch(`supportChat/${chatId}/mark-read-by-admin`);
};

export const updateChatAccessAPI = async (userId, access) => {
  const response = await axiosInstance.patch(`users/${userId}/chat-access`, {
    access,
  });
  return response.data;
};
